// extracted by mini-css-extract-plugin
export default {"update-link":"aTEUp","active":"F_qRt","inactive":"Xpdql","icon":"JbbHR"};